import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { BookContext } from "../../contexts/BookContext";
import { Chapter } from "../../types/models";

type Props = {
  chapter: Chapter;
  percentage: number;
  onAnecdotesClick?: () => void;
};

export const ChapterTableActionsButton: FC<Props> = ({
  chapter,
  percentage,
  onAnecdotesClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (isDisabled) return;

    navigate(`/chapter/${chapter.number}/`);
  };

  const bookContext = useContext(BookContext);
  const status = bookContext?.book?.status;
  const statusToDisable = [
    "ai_generating",
    "ai_generated",
    "completed",
    "pdf_generating",
    "pdf_generated",
  ];
  const isDisabled = status && statusToDisable.includes(status);

  const label =
    percentage === 0
      ? t("chapter.actions.start")
      : percentage === 100
      ? t("chapter.actions.edit")
      : t("chapter.actions.resume");

  const classes = [
    isDisabled
      ? "border-gray-100 text-slate-600"
      : "border-delicate-50 hover:bg-delicate-10 text-delicate-700",
    "px-6 py-1 inline-flex text-l leading-5 font-normal rounded-full border-2",
  ];

  return (
    <div className="flex gap-2 justify-end">
      <button
        type="button"
        className="px-6 py-1 inline-flex text-l leading-5 font-normal rounded-full border-2 border-herb-50 hover:bg-herb-10 text-herb-700"
        onClick={onAnecdotesClick}
      >
        Témoignages
      </button>
      <button
        type="button"
        className={classes.join(" ")}
        onClick={() => handleNavigate()}
        disabled={isDisabled}
      >
        {label}
      </button>
    </div>
  );
};
